import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Logo from '../../assets/icons/logo-white.png';
import {
  Menu as MenuIcon,
  Home,
  ExpandLess,
  ExpandMore,
  ChevronRight,
  ChevronLeft,
  Logout,
} from '@mui/icons-material';
import { Collapse, IconButton, Typography } from '@mui/material';

const drawerWidth = 280;
const navMenuItems = [{ label: 'Merchants', icon: <Home />, to: '' }];

const openedMixin = (theme) => ({
  width: drawerWidth,
  backgroundColor: '#111827',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  backgroundColor: '#111827',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundColor: 'white',
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

export default function Header(props) {
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);
  const [userData, setUserData] = useState(null);
  const [openCollapse, setOpenCollapse] = React.useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('user')) {
      setUserData(JSON.parse(localStorage.getItem('user')));
    }
  }, []);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const logout = () => {
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position='fixed' open={open}>
        <Toolbar>
          <IconButton
            color='inherit'
            aria-label='open drawer'
            onClick={handleDrawerOpen}
            edge='start'
            sx={{
              color: 'black',
              marginRight: 5,
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Box
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            {/* <div> */}
            <span
              id='basic-button'
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup='true'
              aria-expanded={open ? 'true' : undefined}
              style={{
                color: 'black',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
              }}
            >
              <div style={{ margin: 10 }}>
                <Typography variant='body1'>Welcome, {userData?.firstName}</Typography>
              </div>
              <IconButton
                onClick={logout}
                style={{
                  color: '#0000008A',
                  cursor: 'pointer',
                }}
              >
                <Logout />
              </IconButton>
            </span>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer variant='permanent' open={open}>
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}
          sx={{
            color: '#FFFFFFB3',
          }}>
            {theme.direction === 'rtl' ? <ChevronRight /> : <ChevronLeft />}
          </IconButton>
        </DrawerHeader>
        {open && (
          <img
            src={Logo}
            alt='side nav logo'
            style={{
              height: 100,
              width: 230,
              alignSelf: 'center',
              objectFit: 'cover',
            }}
          />
        )}
        <List>
          {navMenuItems.map((item) => (
            <ListItem
              key={item.label}
              disablePadding
              sx={{ display: 'block',
                color: '#FFFFFFB3'}}
              onClick={() => {
                !item.child && navigate(item.to);
              }}
            >
              <ListItemButton
                onClick={() => {
                  item.child && setOpenCollapse(!openCollapse);
                }}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    color: '#FFFFFFB3',
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.label} sx={{ opacity: open ? 1 : 0 }} />
                {item.child && <>{openCollapse ? <ExpandLess /> : <ExpandMore />}</>}
              </ListItemButton>
              {item.child && (
                <Collapse in={openCollapse} timeout='auto' unmountOnExit>
                  {item.child.map((childItem) => (
                    <List key={childItem.label} component='div' disablePadding>
                      <ListItem onClick={() => navigate(childItem.to)}>
                        <ListItemButton sx={{ pl: 4 }}>
                          <ListItemText primary={childItem.label} />
                        </ListItemButton>
                      </ListItem>
                    </List>
                  ))}
                </Collapse>
              )}
            </ListItem>
          ))}
        </List>
      </Drawer>
      <Box component='main' sx={{ flexGrow: 1 }}>
        <DrawerHeader />
        <main>{props.children}</main>
      </Box>
    </Box>
  );
}

Header.propTypes = {
  children: PropTypes.any,
};
